<template>
  <AuthLayoutFull center>
    <ZipCodeForm slot="content" />
  </AuthLayoutFull>
</template>

<script>
import AuthLayoutFull from '@/components/auth/AuthLayoutFull'
import ZipCodeForm from '@/components/ZipCodeForm'

export default {
  components: {
    ZipCodeForm,
    AuthLayoutFull
  }

}
</script>
